import React from 'react'
import ReactDOM from 'react-dom'
import {browserHistory} from 'react-router'
import { niceNumber } from '../components/payslip';
import ArrowBackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import logo from '../images/morrilogobw.png'
import PageviewGA from '../components/pageview-ga'

function updateDimensions() {
    //todo client width - draw width if nav is open
    if(ReactDOM.findDOMNode(this)){
        const parent = ReactDOM.findDOMNode(this).parentNode
        let scale = parent.offsetWidth / 800
        this.setState({scale});
    }
}


export default class extends React.Component {

	constructor(props){
		super(props)
		this.payslip = this.props.store.print_payslip
        this.state = {"scale": 1}
        this.updateDimensions = updateDimensions.bind(this)
	}

    componentDidMount() {
		if(!this.payslip){
			return browserHistory.replace('/latest-payslip')
		}
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions)
        setTimeout(() => {
        	window.print()
        }, 1000)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions)
    }


    yearToDate() {
        let data = {
            classes: ["","align-right"],
            headers: ["Year to date", "Value"],
            rows:
                this.payslip.year_to_date.map( (obj) => {
                    let key = Object.keys(obj)[0]
                    return [key, niceNumber(obj[key])]
                })
        }

        return <MyTable data={data} className="hide-border-left minimum-height"/>
    }

    deductions() {
        let data = {
            classes: ["", "align-right"],
            headers: ["Deductions", "Value"],
            rows:
                this.payslip.deductions.map( (obj) => {
                    let key = Object.keys(obj)[0]
                    return [key, niceNumber(obj[key])]
                })
        }

        return <MyTable data={data} className="hide-border-left"/>
    }

    payments() {
        let data = {
            classes: ["", "align-right", "align-right"],
            headers: ["Payments", "Units", "Value"],
            rows:
                this.payslip.payments.map( (obj) => {
                    let key = Object.keys(obj)[0]
                    return [key, niceNumber(obj[key][0]), niceNumber(obj[key][1]) ]
                })
        }

        return <MyTable data={data} />
    }

    holiday() {
        let data = {
            classes: ["",""],
            rows:
                this.payslip.holiday.map( (obj) => {
                    let key = Object.keys(obj)[0]
                    return [key, obj[key]]
                })
        }

        return <MyTable data={data}/>
    }

    taxData() {
        let data = {
            classes: ["",""],
            rows:
                this.payslip.tax_data.map( (obj) => {
                    let key = Object.keys(obj)[0]
                    return [key, obj[key]]
                })
        }

        return <MyTable data={data} className="hide-border-left"/>
    }

    payslipDates() {
        let pay_period = this.payslip.pay_period

        let data = {
            classes: ["", ""],
            flexClasses: ["flex-50", "flex-50"],
            rows: [
                ["Period Ending:",  pay_period.period_ending],
                ["Payment Due Date:",  pay_period.payment_due_date],
                ["Tax Week:",  pay_period.tax_week],
            ]
        }

        return <MyTable data={data} className="hide-border"/>
    }

    employeeInfo() {
        const current_user = this.props.store.current_user

        const data = {
            classes: ["", ""],
            flexClasses: ["flex-50", "flex-50"],
            rows: [
                ["Name:",  `${current_user.first_name} ${current_user.last_name}`],
                ["ID Number:",  current_user.employee_id],
                ["Location:",  current_user.store_name ? `${current_user.store_name} (${current_user.store_id})` : ''],
                ["Department:",  this.payslip.colleague_data ? this.payslip.colleague_data.department : ''],
            ]
        }

        return <MyTable data={data} className="hide-border"/>
    }

    render() {
    	if(!this.payslip) return null       
    	return (
            <div>
                <PageviewGA/>
            	<div id="title_bar" style={{borderBottom: "2px solid #2ea836", padding: "16px"}}>
	            	<div style={{display: "inline-block"}}>
	            		<div onClick={() => browserHistory.goBack()} style={{fontSize: "24px", color: "#2ea836", cursor: "pointer"}} className="layout-row layout-align-center">
		            		<ArrowBackIcon style={{color: "#2ea836", width: "34px"}}/>
		            		<div>Back to My Pay</div>
		            	</div>
		            </div>
	            	<p style={{margin: "5px"}}>
	            		The print dialogue should open automatically. If it doesn't open, please use your browser's print option.
	            	</p>
            	</div>
            	<div className="print_content" ref="content" style={{padding: "16px", position: "absolute", minWidth: "800px", minHeight: "100%", transform: "scale("+this.state.scale+")", transformOrigin: "top left"}}>

            		<div className="layout-row flex layout-justify-space-between layout-align-center">
            			<div style={{fontSize: "20px", marginTop: "15px", fontWeight: "bold"}}>PRIVATE AND CONFIDENTIAL</div>
            			<img src={logo} alt="morrisons logo" height="100px"/>
            		</div>

	                <div style={{padding: "16px"}}></div>

	                <div className="layout-row flex">
	                    <div className="layout-row flex-33">
	                        <div id="employee_info" className="layout-row flex">
	                            {this.employeeInfo()}
	                        </div>
	                    </div>
	                    <div className="flex-20"></div>
	                    <div className="layout-row flex-33">
	                        <div id="pay_period" className="layout-row flex">
	                            {this.payslipDates()}
	                        </div>
	                    </div>
	                </div>

	                <div style={{padding: "8px"}}></div>

	                <div className="layout-row flex">

	                    <div className="layout-row flex-40">
	                        <div className="layout-row flex">
	                            <div id="payments" className="layout-column flex">
	                                {this.payments()}
	                                <TableSummary row={["TOTAL PAYMENTS", niceNumber(this.payslip.colleague_data.total_payments)]}/>
	                            </div>
	                        </div>
	                    </div>

	                    <div className="layout-row flex-30">
	                        <div className="layout-row flex">
	                            <div id="deductions" className="layout-column flex">
	                                {this.deductions()}
	                                <TableSummary row={["TOTAL DEDUCTIONS", niceNumber(this.payslip.colleague_data.total_deductions)]}  className="hide-border-left"/>
	                            </div>
	                        </div>
	                    </div>

	                    <div className="layout-row flex-30">
	                        <div className="layout-row flex">
	                            <div id="year_to_date" className="layout-column flex">
	                                {this.yearToDate()}
	                                <TableSummary row={["NET PAY", niceNumber(this.payslip.colleague_data.net_pay)]} className="net-pay hide-border-left"/>
	                            </div>
	                        </div>
	                    </div>

	                </div>
	                <div style={{padding: "16px"}}></div>
	                <div className="layout-row flex">

	                    <div className="layout-row flex-70">
	                        <div id="holiday" className="layout-column flex">
	                            {this.holiday()}
	                        </div>
	                    </div>

	                    <div className="layout-row flex-30">
	                        <div id="tax_data" className="layout-column flex">
	                            {this.taxData()}
	                        </div>
	                    </div>
	                </div>
	                <br/><br/><br/>
	            </div>
            </div>
    	)
        
    }

}

function TableSummary(props) {
    return(
        <div className={`layout-row layout-justify-space-between layout-align-center my-summary-row ${props.className}`}>
            <div>{props.row[0]}</div>
            <div className="my-summary-total">{props.row[1]}</div>
        </div>
    )
}

function MyTable(props) {

    let data = props.data

    let colClass = ["flex", "flex-20", "flex-33"]
    if ( data.classes.length === 2 ) {
        colClass = ["flex","flex-33"]
    }

    if(data.flexClasses){
    	colClass = data.flexClasses
    }

    let addonClassName = data.classes

    let headers = (data.headers || [] ).map( (p,i) => {
        return <div key={`${i}-header`} className={`my-table-cell ${colClass[i]} ${addonClassName[i]}`}>{p}</div>
    })

    let rows = data.rows.map( (row,i) => {
        let elems = row.map( (p, i) => {
            return <div key={`${i}-elem`} className={`my-table-cell ${colClass[i]} ${addonClassName[i]}`}>{p}</div>
        })



        return  <div className={`my-table-row layout-row ${i === 0 ? "first-row" : ""} ${data.rows.length === i+1 ? "last-row" : ""}`} key={`${i}-row`}>{elems}</div>
    })

    return (
        <div className={`my-table layout-column flex ${props.className}`}>
            {headers.length !== 0 ?
                <div className="layout-row my-table-heading">
                    {headers}
                </div>
                : null }
            {rows}
            {props.children}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/pages/print_view.js